<template>
	<el-menu mode="vertical" :collapse="isCollapse" unique-opened :default-active="$route.path" background-color="#324157" text-color="#bfcbd9" active-text-color="#20a0ff" >
	  <sidebar-item :routes='itemRoute'></sidebar-item>
    </el-menu>
</template>

<script>
	import { mapGetters } from 'vuex'
	import SidebarItem from './SidebarItem'
	export default{
		name: 'Sidebar',
		components: { SidebarItem },
		data(){
			return {
				itemRoute: []
			}
		},
		created(){
			this.$nextTick(()=>{
				this.filterRoute();
			})
		},
		computed: {
			...mapGetters([
		      'permission_routers',
		      'sidebar',
					'roles'
		    ]),
		    isCollapse() {
		      return !this.sidebar.opened
		    }
		},
		methods:{
			filterRoute(){
				let _this = this;
				
				_this.itemRoute = _this.permission_routers.filter(function(item, index){
					if(item.children && item.children.length>0){
						let i = _this.lodash.findIndex(item.children, (p)=>{
							return p.hidden != true
						})
						return i != -1;
					}
					return true;
				})

			}
		}
	}

</script>

<style>
	/*.el-menu-vertical-demo:not(.el-menu--collapse) {
	    width: 200px;
	    min-height: 400px;
    }*/
</style>



// WEBPACK FOOTER //
// src/views/layout/Sidebar.vue?0a702f06